<template>
    <div class="person-entry-card">
        <b-row align-h="center">
            <b-col cols="auto">
                <app-avatar :image-url="entry.photo" type="vehicle"></app-avatar>
            </b-col>
        </b-row>
        <b-row align-h="center">
            <b-col cols="auto">
                <h1>{{ entry.vehicle_plate }}</h1>
            </b-col>
        </b-row>
        <b-row align-h="center">
            <b-col cols="auto">
                <h2>{{ entry.created_at | datetime }}</h2>
            </b-col>
        </b-row>
        <b-row align-h="center">
            <b-col cols="auto">
                <h2>{{ entry.structure_name }}</h2>
            </b-col>
        </b-row>
        <b-row align-h="center">
            <b-col cols="auto">
                <h2>{{ entry.door_name }}</h2>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    props: {
        entry: {
            type: Object,
            required: true,
        },
    },
}
</script>

<style>
</style>
